// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__p1FoS","col":"CardReaderDesc_col__2l9PW","label":"CardReaderDesc_label__1Pobs"};